export const HUB_SAUDE_ROUTE = "/hub-de-saude";

export const isHubSaudeItem = (item?: { View?: string; view?: string; Label?: string } | null): boolean => {
  const view = String(item?.View || item?.view || "");
  return view === HUB_SAUDE_ROUTE || view.startsWith(`${HUB_SAUDE_ROUTE}/`);
};
